var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_461_3204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6516 17.7646C25.3019 13.9938 14.8282 13.647 8.76668 15.4867C7.79325 15.7822 6.76386 15.2324 6.46901 14.2593C6.17396 13.2853 6.72289 12.2566 7.69705 11.9607C14.6553 9.84862 26.2223 10.2565 33.5322 14.5957C34.4077 15.1155 34.6949 16.2463 34.176 17.1203C33.6566 17.9958 32.5249 18.2844 31.6516 17.7646ZM31.4436 23.3498C30.9981 24.0727 30.053 24.2995 29.3311 23.8556C24.0373 20.6016 15.9652 19.6589 9.70234 21.56C8.89018 21.8054 8.03234 21.3475 7.78563 20.5369C7.54093 19.7247 7.99907 18.8684 8.80978 18.6215C15.9642 16.4504 24.8583 17.502 30.9384 21.2384C31.6603 21.683 31.8875 22.6286 31.4436 23.3498ZM29.0333 28.7137C28.6793 29.2942 27.9235 29.4761 27.3451 29.1222C22.7193 26.2951 16.897 25.6567 10.0402 27.2228C9.37945 27.3743 8.72091 26.9602 8.57022 26.2995C8.41888 25.639 8.83137 24.9804 9.49358 24.8296C16.9972 23.1143 23.4338 23.8525 28.6259 27.0252C29.2047 27.3788 29.387 28.135 29.0333 28.7137ZM19.9993 0.301544C9.12025 0.301544 0.300781 9.12083 0.300781 19.9997C0.300781 30.8799 9.12025 39.6984 19.9993 39.6984C30.8786 39.6984 39.6977 30.8799 39.6977 19.9997C39.6977 9.12083 30.8786 0.301544 19.9993 0.301544Z",
    fill: "#1ED760"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_461_3204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.f503f408570ea3025e52bda92df345df.svg";
export { ForwardRef as ReactComponent };